import React, { useState } from 'react';
import { SxStyle } from '../../../../types';
import Switch from '@mui/material/Switch';
import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import { doc, updateDoc } from 'firebase/firestore';
import firebaseApp from '../../../../firebase-app';
import { useSnackbar } from 'notistack';
import { useStringsContext } from '../../../../contexts/strings';

const styles: SxStyle = {
  switchContainer: {
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
  },
  progress: {
    marginLeft: '8px',
  },
};

interface Props {
  pushNotificationSettings: any;
  selectedAbbrv: string;
  isLoading?: boolean;
  save: (value: boolean) => any;
}

const PushNotificationSelect = ({ pushNotificationSettings, isLoading, save }: Props) => {
  const { strings } = useStringsContext();
  const { enqueueSnackbar } = useSnackbar();

  const onActiveChanged = async (checked: boolean) => {
    try {
      const res = await save(checked);
      if (res.error) {
        throw new Error();
      }
      const message = strings.messages.pushNotificationSuccess;
      enqueueSnackbar(message, {
        variant: 'success',
      });
    } catch (error: any) {
      console.error(error);

      enqueueSnackbar(strings.messages.saveError, {
        variant: 'error',
      });
    }
  };

  return (
    <Box sx={styles.switchContainer}>
      {isLoading ? (
        <CircularProgress size={24} sx={styles.progress} />
      ) : (
        <Switch
          size="small"
          checked={pushNotificationSettings.automation}
          onChange={(event, checked) => {
            onActiveChanged(checked);
          }}
        />
      )}
    </Box>
  );
};

export default PushNotificationSelect;
